import { decorators, CONSTANTS } from '@sohohouse/platform-resources'
import { platformGetters } from '~/helpers/store'

const EventBooking = decorators.dh.EventBooking


export default {
  ...platformGetters,
  bookingById: (s, getters) => id =>
    getters.resourceById(id) ? new EventBooking(getters.resourceById(id)) : null,
  eventBookings: (s, getters) =>
    getters.resources.map(booking => new EventBooking(booking)),
  activeEventBookings: (s, getters) => getters.eventBookings
    .filter(booking => booking.status !== CONSTANTS.EVENT_BOOKING_STATUSES.CANCELLED),
  eventBookingsByType: (s, getters) => (type, sort = true) => {
    if (s.cached[type]) {
      const bookingIds = s.cached[type].data
      const bookings = bookingIds.map(id => new EventBooking(getters.resourceById(id)))
      if (sort) {
        return bookings.sort((a, b) => a.event.startsAt.epoch - b.event.startsAt.epoch)
      }
      return bookings
    }
    return []
  },
  uniqueEventBookings: (s, { eventBookingsByType }) => {
    const uniqueBookings = eventBookingsByType('previous', false).reduce((bookings, booking) => {
      if (!bookings.some(({ event }) => event.id === booking.event.id)) {
        return [...bookings, booking]
      }

      return bookings
    }, [])

    return uniqueBookings.sort((a, b) => a.event.startsAt.epoch + b.event.startsAt.epoch)
  },
  isPageComplete: s => type => {
    const cached = s.cached[type]
    if (cached) {
      return cached.meta.page >= cached.meta.totalPages
    }
    return false
  },
  getFetching: s => s.meta.fetching,
  membersEventFetching: s => s.meta.membersEventFetching,
  houseVisitFetching: s => s.meta.houseVisitFetching,
  inductionFetching: s => s.meta.inductionFetching,
  screeningFetching: s => s.meta.screeningFetching,
  fitnessFetching: s => s.meta.fitnessFetching,
  membersEventFetched: s => s.meta.membersEventFetched,
  houseVisitFetched: s => s.meta.houseVisitFetched,
  inductionFetched: s => s.meta.inductionFetched,
  screeningFetched: s => s.meta.screeningFetched,
  fitnessFetched: s => s.meta.fitnessFetched
}
